import type { Environment } from 'config/environment'

import { init } from 'modules/core/lib/buildUrl'

export default (environment: Environment) => {
  init(environment)
}
